import { useEffect, useState } from 'react'

const TOUCH_QUERY = '(pointer: coarse)'

// Detects touch-primary devices via the `pointer: coarse` media query. The
// onboarding tour popup is anchored at a fixed position and can overflow the
// edge of a narrow touch screen, pushing its close button out of reach; on
// touch devices we surface a tap-outside-to-dismiss escape hatch instead.
//
// Returns `false` during SSR / when `matchMedia` is unavailable, and stays in
// sync if the primary pointer type changes (e.g. a tablet docked to a mouse).
export const useIsTouchDevice = (): boolean => {
  const [isTouch, setIsTouch] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return

    const query = window.matchMedia(TOUCH_QUERY)
    setIsTouch(query.matches)

    const onChange = (event: MediaQueryListEvent) => setIsTouch(event.matches)
    query.addEventListener('change', onChange)
    return () => query.removeEventListener('change', onChange)
  }, [])

  return isTouch
}
